import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Students({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="0 -6.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M1.52028644 10.1172L20.4326424 1.33186667 39.3456593 10.1172l-18.9130169 8.236zM9.8375322 21.6276c0 2.6326667 4.7434576 4.7666667 10.5954407 4.7666667 5.851322 0 10.5954407-2.134 10.5954407-4.7666667M9.8375322 14.3307333v6.9373334M31.0281492 21.2682v-6.9373333M35.2915763 12.0810667v10.5966666" />
      </g>
    </svg>
  )
}

Students.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
